
import { useRef, useCallback } from "react";

export const useSearchFocus = () => {
  // References to input elements
  const searchInputRef = useRef<HTMLInputElement | null>(null);
  
  // Register the search input reference
  const registerSearchInput = useCallback((ref: HTMLInputElement | null) => {
    if (ref !== searchInputRef.current) {
      console.log("Registering new search input reference");
      searchInputRef.current = ref;
    }
  }, []);
  
  // Focus the search input
  const focusSearchInput = useCallback(() => {
    if (searchInputRef.current) {
      console.log("Focusing search input");
      searchInputRef.current.focus();
      
      // Preserve the current text selection if any
      const length = searchInputRef.current.value.length;
      if (length > 0) {
        try {
          // Place cursor at the end of the text
          searchInputRef.current.setSelectionRange(length, length);
        } catch (err) {
          console.error("Error setting selection range:", err);
        }
      }
    } else {
      console.warn("Cannot focus search input - ref not set");
    }
  }, []);
  
  return {
    registerSearchInput,
    focusSearchInput,
    searchInputRef
  };
};
